import { Component, EventEmitter, Input, Output}    from '@angular/core';

@Component({
  template: require('./booking.request.actions.component.html')
})
export class BookingRequestActionsComponent {
  @Input() record: any;

  @Output() onEditClick  : EventEmitter<any> = new EventEmitter();
  @Output() onDeleteClick: EventEmitter<any> = new EventEmitter();
  constructor () {}
}